'use client'

import React, { useMemo } from 'react'
import { useLocale, useTranslations } from 'next-intl'

import heyaTrendingHotelsData from '@/src/constants/hotels/heyaTrendingHotels.json'
import trendingHotelsData from '@/src/constants/trendingHotels.json'
import { useIsHeya } from '@/src/hooks/useThemeKey'

import { TrendingHotels } from './trendingHotels'

interface TrendingHotelsData {
    title: string
    title_ar?: string
    hotels: Array<{
        id: string
        title_en: string
        title_ar?: string
        location_en: string
        location_ar?: string
        rating: number
        imageUrl: string
        href_en: string
        href_ar?: string
    }>
}

export const TrendingHotelsWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    // Heya lists Saudi hotels only; every other host keeps the default list.
    const isHeya = useIsHeya()
    const data = (isHeya ? heyaTrendingHotelsData : trendingHotelsData) as TrendingHotelsData
    const isArabic = locale === 'ar'

    const hotels = useMemo(
        () =>
            data.hotels.map(hotel => ({
                ...hotel,
                title: isArabic ? hotel.title_ar || hotel.title_en : hotel.title_en,
                location: isArabic ? hotel.location_ar || hotel.location_en : hotel.location_en,
                href: isArabic ? hotel.href_ar || hotel.href_en : hotel.href_en
            })),
        [data.hotels, isArabic]
    )

    if (!data || !data.hotels || data.hotels.length === 0) {
        return null
    }

    return (
        <TrendingHotels
            title={t('trendingHotels') || (isArabic ? data.title_ar || data.title : data.title)}
            hotels={hotels}
        />
    )
}

export default TrendingHotelsWrapper
